export default "//cloud.imgsmail.ru/cloud.mail.ru/146512/img/build/quota-landing/appStore.png";